export default defineNuxtRouteMiddleware((to) => {
  /* const redirects: Record<string, string> = {
    '/menu': '/menu',
    '/en/menu': '/en/menu',
    '/de/menu': '/de/menu',
    '/carta-vini': '/carta-vini',
    '/en/carta-vini': '/en/carta-vini',
    '/de/carta-vini': '/de/carta-vini',
  }

  if (!redirects[to.path]) {
    // return navigateTo('/menu', { replace: true }) // Reindirizza a "/menu" se l'URL non è previsto
  } */
})
